<div class="drawers"
	[ngClass]="{
		'drawer-two-open': (pinnedDrawerItems().length === 2),
		'drawer-three-open': (pinnedDrawerItems().length === 3),
		'drawer-four-open': (pinnedDrawerItems().length === 4),
		'drawer-five-open': (pinnedDrawerItems().length === 5)
	}">

	<ng-template ngFor
		let-drawerMenuItem
		[ngForOf]="allActiveDrawers()"
		[ngForTrackBy]="trackByLabel">

		<div [class.overlay-drawer]="isOverlayItem(drawerMenuItem)"
			[class.div]="!isOverlayItem(drawerMenuItem)"
			[ngClass]="getOverlayOffsetClass(drawerMenuItem)"
			[@drawerAnimation]="getDrawerAnimationState(drawerMenuItem)">
			<app-drawer [pageContext]="pageContext()"
				[drawerMenuItem]="drawerMenuItem"
				(drawerCloseButtonClicked)="closeDrawerClick($event)"
				(drawerPinButtonClicked)="pinDrawerClick($event)">
			</app-drawer>
		</div>

	</ng-template>
</div>